import React, { useState, useEffect } from 'react';
import Portal from './Portal';

const ProjectModal = ({ isOpen, onClose, onSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    vision: '',
    mission: '',
    status: 1
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Reset form when modal opens or initialData changes
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        description: initialData.description || '',
        vision: initialData.vision || '',
        mission: initialData.mission || '',
        status: initialData.status || 1
      });
    } else {
      setFormData({
        name: '',
        description: '',
        vision: '',
        mission: '',
        status: 1
      });
    }
    setError('');
  }, [isOpen, initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.name.trim()) {
      setError('Project name is required');
      return;
    }
    
    const formattedData = {
      name: formData.name.trim(),
      description: formData.description || '',
      vision: formData.vision || '',
      mission: formData.mission || '',
      status: parseInt(formData.status) || 1
    };
    
    console.log('ProjectModal submitting data:', formattedData);
    setLoading(true);
    
    onSubmit(formattedData);
  };

  // Don't render anything if modal is closed
  if (!isOpen) return null;

  return (
    <Portal>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="close-modal" onClick={onClose} aria-label="Close modal">&times;</button>
          <h2 id="modal-title">{initialData ? 'Edit Project' : 'Create New Project'}</h2>
          
          {error && <div className="error-message">{error}</div>}
          
          <form id="project-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Project Name</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter project name"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea 
                id="description" 
                name="description" 
                value={formData.description}
                onChange={handleChange}
                placeholder="Project description (optional)"
                rows="3"
              />
            </div>

            <div className="form-group">
              <label htmlFor="vision">Vision</label>
              <textarea 
                id="vision" 
                name="vision" 
                value={formData.vision}
                onChange={handleChange}
                placeholder="Project vision (optional)"
                rows="2"
              />
            </div>

            <div className="form-group">
              <label htmlFor="mission">Mission</label>
              <textarea 
                id="mission" 
                name="mission" 
                value={formData.mission}
                onChange={handleChange}
                placeholder="Project mission (optional)"
                rows="2"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="status">Status</label>
              <select 
                id="status" 
                name="status" 
                value={formData.status}
                onChange={handleChange}
                required
              >
                <option value={1}>Open</option>
                <option value={2}>In Progress</option>
                <option value={3}>Closed</option>
              </select>
            </div>
            
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Creating...' : (initialData ? 'Update Project' : 'Create Project')}
            </button>
          </form>
        </div>
      </div>
    </Portal>
  );
};

export default ProjectModal; 